import { ProtocolError } from "./ProtocolError";

export class FeatureTriggerConsistencyError extends ProtocolError {
  public constructor(message: string) {
    super(message);
    this.name = "FeatureTriggerConsistencyError";
  }
}

export class FeatureFlowValidationError extends ProtocolError {
  public constructor(message: string) {
    super(message);
    this.name = "FeatureFlowValidationError";
  }
}
